import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 17c0 -6.075 -5.373 -11 -12 -11","key":"svg-0"}],["path",{"d":"M3 3v18h18","key":"svg-1"}]]

const IconChartPpf = createReactComponent('outline', 'chart-ppf', 'ChartPpf', __iconNode);

export default IconChartPpf;